import { render, staticRenderFns } from "./TourBackground.vue?vue&type=template&id=e3bdf328&"
import script from "./TourBackground.vue?vue&type=script&lang=ts&"
export * from "./TourBackground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports